export default __webpack_public_path__ + "static/media/cbr1.125ee2a5.PNG";